module.exports = __webpack_public_path__ + "static/img/e2.4bef12e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/e2.png
// module id = w5YB
// module chunks = 0